module.exports = __webpack_public_path__ + "img/twitter.a4dfaf02.png";